$(function () {

  $(window).on("load", function () {
    $("body").addClass("loaded");
  });

  $(window).on("scroll", function () {
    if ($(window).scrollTop() >= 50) {

    } else {

    }
  });

  try {
    $('.featured-banner-slider-wrapper').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      autoplaySpeed:4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      nextArrow: '.next-btn',
      prevArrow: '.prev-btn'
    });
    $('.hero-slider').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 1500,
      autoplaySpeed:4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows:false
    });
    $('.hero-slider').mouseover(function() {
      $(this).slick('play')
    });
  }catch (exceptionVar) {
    console.log(exceptionVar);
  } 
  try {
    $('#project-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      autoplaySpeed:3000,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      nextArrow: false,
      prevArrow: false,
      responsive: [
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ]
    });
    $('.image-slider-left').slick({
      dots: false,
      infinite: false,
      speed: 500,
      autoplaySpeed:3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: '.next-left',
      prevArrow: '.prev-left',
    });
    $('.image-slider-right').slick({
      dots: false,
      infinite: false,
      speed: 500,
      autoplaySpeed:3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: '.next-right',
      prevArrow: '.prev-right',
    });
    $(window).resize(function(){
      $('#project-slider')[0].slick.refresh();
    });
  }catch (exceptionVar) {
    console.log(exceptionVar);
  }   

  // Header and footer scripts starts
  $('#search-toggle').click(function(){
    $('.search-input-block').toggleClass('active');
    $('.menu-items-list').toggleClass('hide-menu');
  })

  $('.has-dropdown').click(function(){
    if ($(this).hasClass("dropdown_active")) {
      $(this).removeClass('dropdown_active');
    }else{
      $('.has-dropdown').removeClass('dropdown_active');
      $(this).addClass('dropdown_active');
    }
  });
  $('.mobile-bread-crumb').click(function(){
    $('.menu-items-list').toggleClass('mob-menu-open');
    $(this).toggleClass('open');
    $('.search-block-mobile').removeClass('active-search');
  });
  $('#search-block-mob').click(function(){
    if($('.search-block-mobile').hasClass("active-search")){
      $('.search-block-mobile').removeClass('active-search');
    }else{
      $('.search-block-mobile').addClass('active-search');
    }
  });
  $('.mob-click-toggle').click(function(){
    $(this).parents('.nav-block').toggleClass('mob-open');
  });
  // Header and footer scripts ends

  $('.mouse-element').click(function(){
    $('html, body').animate({
      scrollTop: $("#home-our-service").offset().top
    }, 300);
  });
  try{
    setTimeout(() => {
      $('.banner-with-loader').addClass('banner-active');
    }, 1200);
  }catch (exceptionVar) {
    console.log(exceptionVar);
  }  
  // Who we are page starts
  try{
    $('.show-more').click(function(){
      $('#our-story-data').addClass('show-more-active');
    });
    $('.show-less').click(function(){
      $('#our-story-data').removeClass('show-more-active');
    });
  }catch(exceptionVar) {
    console.log(exceptionVar);
  }
  // Who we are page ends
  $('.filter-tab-list li').click(function(){
    var activeTab = $(this).attr('data-item');
    $('.filter-tab-list li').removeClass('active');
    $('.content-block').removeClass('active');
    $(this).addClass('active');
    $('#'+activeTab).addClass('active');
  });

  $('.phase-link').click(function(){
    if ($(this).parents('.phase-btn').hasClass("active")) {
      $('.phase-btn').removeClass('active');
      $(this).parents('.phase-btn').removeClass('active');
    }else{
      $('.phase-btn').removeClass('active');
      $(this).parents('.phase-btn').addClass('active');
    }
  });

  setTimeout(() => {
		$('.title-txt').each(function() {
			var $this = $(this),
					countTo = $this.attr('data-count');
			
			$({ countNum: $this.text()}).animate({
				countNum: countTo
			},
			{
				duration: 5000,
				easing:'linear',
				step: function() {
					$this.text(Math.floor(this.countNum));
				},
				complete: function() {
					$this.text(this.countNum);
					//alert('finished');
				}
			});  
		
		});
		function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    // $('.service-count-text').each(function () {
    //   var $this = $(this),
    //       countTo = $this.attr('data-count');
    //   $({
    //     countNum: $this.text()
    //   }).animate({
    //     countNum: countTo
    //   }, {
    //     duration: 5000,
    //     easing: 'linear',
    //     step: function step() {
    //       $this.text(Math.floor(this.countNum));
    //     },
    //     complete: function complete() {
    //       $this.text(numberWithCommas(countTo)); //alert('finished');
    //     }
    //   });
    // });
	}, 500);


  $('.filter-tab-list li').click(function (e) { 
    $('html, body').animate({
        scrollTop: $('.service-full-wrapper .right-block').offset().top - 120
    }, 'slow');
  });


});

$(document).ready(function () {
  $(".pre-loader").delay(100).fadeOut("fast");
});